import i18n from 'i18next';

import { registerValidator } from 'core/forms';

import getEnrollmentsMaximum from '../helpers/getEnrollmentsMaximum';

const isCourseEnrollmentsLimitEnforced = ({ validator }) => {
  const { enrolledUsers, enrollmentsSelectedUsers } = validator;
  const { difference, shouldEnforceMaximum, maximum } = getEnrollmentsMaximum({
    enrolledUsers,
    enrollmentsSelectedUsers,
  });

  return {
    error: i18n.t('max-enrollments-reached'),
    hasError: shouldEnforceMaximum && maximum && difference > 0,
  };
};

registerValidator('isCourseEnrollmentsLimitEnforced', isCourseEnrollmentsLimitEnforced);

export default isCourseEnrollmentsLimitEnforced;
